import React, { useState } from 'react';
import BrandLogo from './BrandLogo';
import ClinicForm from '../components/Form/TuMesaYaForm';
import { FormData } from '../types';
import { submitLeadToWebhook } from '../utils/api';
import { useTracking } from '../hooks/useTracking';

type SubmitState = 'idle' | 'success' | 'error';

const TrialPage: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitState, setSubmitState] = useState<SubmitState>('idle');
  const { trackPageView } = useTracking();

  React.useEffect(() => {
    trackPageView('tuclinicaya-prueba-30-min', 'telemarketing');
  }, [trackPageView]);

  const handleSubmit = async (formData: FormData) => {
    setIsSubmitting(true);
    setSubmitState('idle');

    const response = await submitLeadToWebhook({
      ...formData,
      clinic: formData.restaurant,
      brand: 'CitasClinicas.AI',
      vertical: 'dental',
      source: 'tuclinicaya-telemarketing-trial-30min',
      timestamp: new Date().toISOString(),
    });

    setIsSubmitting(false);
    setSubmitState(response.success ? 'success' : 'error');
    return response.success;
  };

  return (
    <main className="trial-page">
      <header className="trial-header">
        <a href="/">
          <BrandLogo />
        </a>
        <span>Prueba guiada · 30 minutos</span>
      </header>
      <section className="trial-layout">
        <div className="trial-copy">
          <span className="availability-pill">
            <span className="live-dot" /> Acceso a prueba
          </span>
          <h1>Comprueba cómo atendería CitasClinicas.AI una cita real.</h1>
          <p>
            Déjanos tus datos y activaremos una prueba gratuita de 30 minutos
            para experimentar la recepción por teléfono. El canal de WhatsApp
            llegará muy pronto y todavía no entra en la prueba.
          </p>
          <ol>
            <li>
              <span>1</span> Registras tu clínica
            </li>
            <li>
              <span>2</span> Preparamos el escenario dental
            </li>
            <li>
              <span>3</span> Pruebas llamadas reales
            </li>
          </ol>
          <p className="trial-soon">
            <span className="tab-soon">Próximamente</span> Los mensajes de
            WhatsApp se añadirán a la prueba cuando el canal esté disponible.
          </p>
        </div>
        <div className="trial-form">
          {submitState === 'success' ? (
            <div className="form-success" role="status">
              <span>✓</span>
              <h2>Registro completado.</h2>
              <p>Te contactaremos para activar tu prueba de 30 minutos.</p>
            </div>
          ) : (
            <>
              <small>Registro para la prueba</small>
              <h2>Empezamos por tus datos.</h2>
              <ClinicForm
                onSubmit={handleSubmit}
                isSubmitting={isSubmitting}
                variant="trial"
                compact
                submitLabel="Activar mi prueba"
              />
              {submitState === 'error' && (
                <p className="form-error" role="alert">
                  No hemos podido completar el registro. Inténtalo de nuevo.
                </p>
              )}
            </>
          )}
        </div>
      </section>
      <footer className="trial-footer">
        <span>CitasClinicas.AI</span>
        <small>Recepción inteligente para clínicas dentales.</small>
        <nav className="trial-footer__legal">
          <a href="/politica-privacidad">Política de privacidad</a>
          <a href="/aviso-legal">Aviso legal</a>
          <a href="/terminos">Términos y condiciones</a>
          <a href="/cookies">Política de cookies</a>
          <button type="button" data-cc="show-preferencesModal">
            Configurar cookies
          </button>
        </nav>
      </footer>
    </main>
  );
};

export default TrialPage;
